import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrReviewTopic.ts
var t = () => e("reviewTopic");
//#endregion
export { t as useTrReviewTopic };
